import { DocumentDto } from "../../../data/types";
import { DocumentDataGridSkeleton } from "./components";
import { DataGrid } from "./DataGrid";

export interface DocumentDatagridProps {
  isMobile: boolean;
  isLoading: boolean;
  documents: DocumentDto[];
  loadServerRows: () => void;
}
export const DocumentDataGrid: React.FC<DocumentDatagridProps> = ({
  isLoading,
  documents,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {Boolean(!isLoading) && <DataGrid documents={documents} />}
      {isLoading && <DocumentDataGridSkeleton />}
    </div>
  );
};
